export { ProductSliderSection } from "./component-product-slider-section";
